import axios from "axios";
import { useAuthStore } from "@/store/useStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      useAuthStore.getState().logout();
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: (username, password) => api.post("/auth/login", { username, password }),
  signup: (username, password, name) => api.post("/auth/signup", { username, password, name }),
  me: () => api.get("/auth/me"),
  updateMe: (data) => api.put("/auth/me", data),
};

export const adminUsersApi = {
  list: () => api.get("/admin/users"),
  summary: () => api.get("/admin/summary"),
  create: (data) => api.post("/admin/users", data),
  update: (id, data) => api.put(`/admin/users/${id}`, data),
  delete: (id) => api.delete(`/admin/users/${id}`),
  approve: (id) => api.post(`/admin/users/${id}/approve`),
};

export const groupsApi = {
  list: () => api.get("/groups"),
  create: (g) => api.post("/groups", g),
  get: (id) => api.get(`/groups/${id}`),
  update: (id, g) => api.put(`/groups/${id}`, g),
  delete: (id) => api.delete(`/groups/${id}`),
};

export const membersApi = {
  list: (groupId) => api.get(`/members/${groupId}`),
  create: (m) => api.post("/members", m),
  update: (id, m) => api.put(`/members/${id}`, m),
  delete: (id) => api.delete(`/members/${id}`),
};

export const paymentsApi = {
  list: (groupId) => api.get(`/payments/${groupId}`),
  upsert: (p) => api.post("/payments", p),
};

export const reportsApi = {
  group: (id) => api.get(`/reports/${id}`),
  defaulters: () => api.get("/defaulters"),
};

export const auctionsApi = {
  list: (groupId) => api.get(`/auctions/${groupId}`),
  upsert: (a) => api.post("/auctions", a),
  delete: (id) => api.delete(`/auctions/${id}`),
};
